import {ExpandMoreRounded} from "@mui/icons-material";
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material";
import {FC, useState} from "react"
import {useTranslation} from "react-i18next";
import {IInvoiceDetails} from "../page/contract/ContractInterfaces";
import InvoiceTable from "./InvoiceTable";

const InvoiceDetails:FC <{data: IInvoiceDetails[], showTypographyInnerTable?: boolean}> =
    ({data, showTypographyInnerTable = false}) => {
    const [expanded,setExpanded] = useState(false);
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'invoice'});
    return <>
        <Accordion
            expanded={expanded}
            onChange={() => setExpanded((prev: boolean) => !prev)}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreRounded/>}
                aria-controls="subperiods-content"
                id="superiods-header"
            >
                <Typography>{t('title')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {data && data.length > 0 &&
                    <InvoiceTable data={data} showTypography={showTypographyInnerTable}/>
                }
            </AccordionDetails>
        </Accordion>
    </> 
}



export default InvoiceDetails;